<ng-container [ngSwitch]="props.cardSetLayoutOptions?.layoutType || 'card'">
  <ng-container *ngSwitchCase="'card'">
    <p-card [subheader]="props.description">
      <ng-template pTemplate="content">
        <ng-container *ngTemplateOutlet="layoutTypeContent"></ng-container>
      </ng-template>
    </p-card>
  </ng-container>
  <ng-container *ngSwitchCase="'plain'">
    <dspx-heading [level]="props.headingLevel" [heading]="props.label"></dspx-heading>
    <dspx-description [text]="props.description"></dspx-description>
    <ng-container *ngTemplateOutlet="layoutTypeContent"></ng-container>
  </ng-container>

  <ng-template #layoutTypeContent>
    <div *ngIf="field.parent.type !== 'summary-page'">
      <p-panel [collapsed]="field.props.isCollapsed">
        <ng-template pTemplate="header">
          <div id={{field.key}}-panel-header class="panel-header">
            <div class="col-4 flex items-center">
              <span>{{props.label}}</span>
              <span *ngIf="isSectionMandatory">*</span>
            </div>
            <div class="flex items-center">
              <formly-field [field]="existsField"></formly-field>
            </div>
            <div class="flex items-center">
              <formly-field [field]="notAssessedField"></formly-field>
            </div>
            <span>{{field.props.answeredQuestionCount}}/{{field.props.totalQuestionCount}}</span>            
            <button pButton
                    type="button"
                    class="p-button-text p-button-sm"
                    (click)="setCollapsedStatus(field)"
                    [disabled]="!field.props.exists || field.props.notAssessed">
              {{ field.props.isCollapsed ? 'Show' : 'Hide' }}
            </button>
          </div>
        </ng-template>
        <div *ngIf="!field.props.isCollapsed">
          <!-- Display existing data -->
          <div class="mb-4 p-3 existingDataDisplay" *ngIf="existingData?.length">
            <h4 class="existingDataDisplayHeader">Previous Inspection Data</h4>
            <span><strong>Last inspected on: </strong>{{lastInspectionDate}}</span>
            <div *ngFor="let item of existingData" class="mb-2">
              <strong>{{ getQuestionLabel(item.label) }}:</strong> {{ getDisplayValue(item.value, item.fieldType) }}
            </div>
            <div class="mt-3">
              <button 
                  pButton type="button" 
                  icon="pi pi-copy" 
                  iconPos="right"
                  [disabled]="!canUseExistingData"
                  label="Use Existing Data" 
                  title="Use Existing Data"
                  (click)="onUseExistingData()">
              </button>
            </div>
          </div>
          <ng-container *ngFor="let question of sectionBodyFields">
            <ng-container *ngIf="question.hide != true && question.type != null  ; else noStyle">
              <div class="{{getQuestionLayoutStyleClass(question)}}">
                <formly-field [field]="question"></formly-field>
              </div>
            </ng-container>
            <ng-template #noStyle>
              <div *ngIf="!isQuestionToBeIgnored(question)">
                <formly-field [field]="question"></formly-field>
              </div>
            </ng-template>
          </ng-container>          
        </div>
      </p-panel>
    </div>
    <div *ngIf="field.parent.type === 'summary-page'" class="grid">
      <ng-container *ngFor="let question of field.fieldGroup">
        <ng-container *ngIf="question.hide != true && question.type != null ; else noStyle">
          <div class="{{getQuestionLayoutStyleClass(question)}}">
            <formly-field [field]="question"></formly-field>
          </div>
        </ng-container>
        <ng-template #noStyle>
          <formly-field [field]="question"></formly-field>
        </ng-template>
      </ng-container>
    </div>
  </ng-template>
</ng-container>
